module.exports = __webpack_public_path__ + "img/5007red.7ec092c2.svg";